module.exports = __webpack_public_path__ + "assets/b113.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b113.png
// module id = 585
// module chunks = 0